// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__c19 {
  overflow: hidden;
  white-space: nowrap;

  .suffix__ee5 {
    margin-left: calc(var(--ring-unit) * 0.5);
    font-weight: 400;
    font-size: var(--ring-font-size);
    color: var(--ring-secondary-color);

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/ide-provisioner/plugins-rules/plugins-rule/single-plugin-rule/plugin-rule-name/plugin-rule-name.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;;EAEnB;IACE,yCAAyC;IACzC,gBAAgB;IAChB,gCAAgC;IAChC,kCAAkC;;IAElC,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;AACF","sourcesContent":[".wrapper {\n  overflow: hidden;\n  white-space: nowrap;\n\n  .suffix {\n    margin-left: calc(var(--ring-unit) * 0.5);\n    font-weight: 400;\n    font-size: var(--ring-font-size);\n    color: var(--ring-secondary-color);\n\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__c19`,
	"suffix": `suffix__ee5`
};
export default ___CSS_LOADER_EXPORT___;
